import { useTranslations } from "next-intl";
import { AlertTriangle } from "lucide-react";

export function ErrorFallback({
  message,
  onClick,
}: {
  message: string;
  onClick: () => void;
}) {
  const t = useTranslations("common");
  return (
    <section className="flex flex-1 flex-col items-center justify-center gap-4 px-4 py-12 text-center sm:px-6 md:px-8">
      <div
        className="flex items-center justify-center rounded-full bg-red-100 p-4 hover:scale-125 hover:cursor-pointer dark:bg-red-900"
        onClick={onClick}
      >
        <AlertTriangle className="r h-8 w-8 text-red-600 dark:text-red-300" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
        {t("unknownError")}
      </h1>
      <p className="max-w-md text-base text-gray-600 dark:text-gray-300">
        {message}
      </p>
    </section>
  );
}
